import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { LabelViewComponent } from 'src/app/shared/label-view/label-view.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-piece',
  templateUrl: './piece.component.html',
  styleUrls: ['./piece.component.scss'],
})
export class PieceComponent implements OnInit, OnChanges {
  packageArray;
  @Input() shipmentForm: FormGroup;
  MultiPiecesGroup: FormGroup;
  pieceDataSource = new MatTableDataSource<any>();
  @Input() shipmentData: any;
  @Input() pieceLevelLabelPrint: boolean;
  @Output() updatedForm = new EventEmitter<any>();
  @Output() rowDeleted = new EventEmitter<boolean>();
  @Output() findDuplicatePiecRef = new EventEmitter<any>();
  @ViewChild('dialogPieceRef') dialogPieceRef: TemplateRef<any>;
  pieceDialog: MatDialogRef<any>;

  columns: string[] = [
    'pieceNo',
    'packagingType',
    'packageLength',
    'packageWidth',
    'packageHeight',
    'packageWeight',
    'volumetricWeight',
    'pieceReference',
    'pieceID',
    'status',
    'pieceContentDescription',
    'Action',
    'pieceAction',
  ];
  pieceStatus = [];
  shipmentDataExist: boolean;
  isDuplicate: boolean = false;
  totalWeight: number = 0;
  totalVolumeWeight: number = 0;
  pieceIndex: any;
  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private shipmentService: ShipmentService,
    private errorDialogService: ErrorDialogService,
    private snackBarService: SnackBarService,
    private behaviourService: BehaviourService,
    private dialog: MatDialog //private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'shipmentData':
            if (this.shipmentData.pieces && this.shipmentData.pieces.length > 0) {
              this.pieceDataSource = new MatTableDataSource();
              this.pieceDataSource = new MatTableDataSource(
                (this.shipmentForm.get('pieces') as FormArray).controls
              );
              this.shipmentDataExist = true;
            } else {
              this.AddNewRow();
              this.shipmentDataExist = false;
            }
            break;
        }
      }
    }
  }

  shipmentDetailsFromList() {
    this.getPackageTypes();

    if (this.shipmentData.pieces != undefined && this.shipmentData.pieces.length > 0) {
      this.setObjectIndex();
      this.pieceDataSource = new MatTableDataSource(
        (this.shipmentForm.get('pieces') as FormArray).controls
      );
    }
  }

  ngOnInit(): void {
    this.shipmentDetailsFromList();
    this.calculateTotalWeight();
    this.calculateTotalVolumeWeight();
    this.intialisePieceGroup();
  }

  getVolumetricWeight(i) {
    const pieceLength = this.shipmentForm.getRawValue().pieces[i].packageLength;
    const pieceWidth = this.shipmentForm.getRawValue().pieces[i].packageWidth;
    const pieceHeight = this.shipmentForm.getRawValue().pieces[i].packageHeight;
    if (pieceLength > 0 && pieceWidth > 0 && pieceHeight > 0) {
      const VolumentriWight = (pieceLength * pieceWidth * pieceHeight) / 5000;
      const packageControl = (this.shipmentForm.get('pieces') as FormArray).controls[i];
      packageControl.get('volumetricWeight').setValue(VolumentriWight);
    }
  }

  isValueExist(arrayData, value) {
    return arrayData.includes(value);
  }

  getPackageTypes() {
    this.configService.fetchConfig('packaging_types').then(res => {
      if (res.data) {
        this.packageArray = res.data;
      }
    });
  }

  changePackageType(packagingType, index) {
    const packageControl = (this.shipmentForm.get('pieces') as FormArray).controls[index];
    const packageObj = this.packageArray.filter(item => item.packagingType == packagingType);
    packageControl.get('packageWeight').setValue(packageObj[0].packageWeight);
    packageControl.get('packageLength').setValue(packageObj[0].packageLength);
    packageControl.get('packageWidth').setValue(packageObj[0].packageWidth);
    packageControl.get('packageHeight').setValue(packageObj[0].packageHeight);
    const volumetricWeightValue =
      (packageObj[0].packageLength * packageObj[0].packageWidth * packageObj[0].packageHeight) /
      5000;
    packageControl.get('volumetricWeight').setValue(volumetricWeightValue);
  }

  AddNewRow() {
    const control = this.shipmentForm.get('pieces') as FormArray;
    if (control.controls.length > 998) {
      this.errorDialogService.openDialog('alert.allow999Pieces');
    }
    if (this.shipmentData.status != 'Manifested') {
      const control = this.shipmentForm.get('pieces') as FormArray;
      control.insert(
        (this.shipmentForm.get('pieces') as FormArray).controls.length + 1,
        this.addPieceGroup()
      );
      this.setObjectIndex();
      this.pieceDataSource = new MatTableDataSource(control.controls);
    }
  }

  DeleteRow(VOFormElement, index) {
    if (this.shipmentData.status !== 'Manifested') {
      const control = this.shipmentForm.get('pieces') as FormArray;
      control.removeAt(index);
      this.setObjectIndex();
      this.pieceDataSource = new MatTableDataSource(
        (this.shipmentForm.get('pieces') as FormArray).controls
      );
      this.rowDeleted.emit(true);
    }
  }

  private addPieceGroup(): FormGroup {
    return this.fb.group({
      pieceNo: { value: '', disabled: true },
      packagingType: new FormControl(''),
      packageWeight: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      packageLength: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      packageWidth: new FormControl(
        '',

        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      packageHeight: new FormControl(
        '',

        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      pieceReference: new FormControl(
        '',
        !this.pieceLevelLabelPrint
          ? Validators.compose([])
          : Validators.compose([Validators.required])
      ),
      pieceID: new FormControl({ value: '', disabled: true }),
      pieceContentDescription: new FormControl(''),
      status: new FormControl({ value: '', disabled: true }),
      volumetricWeight: new FormControl({ value: '', disabled: true }),
    });
  }

  private intialisePieceGroup() {
    this.MultiPiecesGroup = this.fb.group({
      noOfPieces: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(250),
          Validators.pattern('^[0-9]*$'),
        ])
      ),
    });
  }

  addMultiplePieces() {
    const control = this.shipmentForm.get('pieces') as FormArray;
    const selectedPieceGroup = control.controls[this.pieceIndex];
    const multiplePieceObj = this.MultiPiecesGroup.value;
    if (control.controls.length + Number(this.MultiPiecesGroup.value.noOfPieces) > 999) {
      this.errorDialogService.openDialog('alert.allowNotMore999pieces', false);
    } else {
      for (let i = 0; i < multiplePieceObj.noOfPieces; i++) {
        const pieceGroup = this.addPieceGroup();
        pieceGroup.patchValue(selectedPieceGroup.value);
        pieceGroup.get('pieceID').setValue('');
        pieceGroup.get('status').setValue('');
        control.insert(this.pieceIndex + i + 1, pieceGroup);
        this.getVolumetricWeight(this.pieceIndex + i + 1);
        this.setObjectIndex();
      }
      this.closPieceDialog();
      this.pieceDataSource = new MatTableDataSource(control.controls);
      this.shipmentForm.markAsDirty();
    }
  }

  getpieceFormControlId(id, control) {
    return (this.shipmentForm.get('pieces') as FormArray).controls[id].get(control);
  }

  setObjectIndex() {
    (this.shipmentForm.get('pieces') as FormArray).controls.forEach(function (currentValue, Index) {
      currentValue.get('pieceNo').setValue(Index + 1);
    });
  }

  generateIndividualPieceLabel(i) {
    const pieceId: any = this.shipmentForm.getRawValue().pieces[i].pieceID;
    if (this.shipmentData.productCode === 'A' || this.shipmentData.productCode === 'B') {
      const selectedPieces = [];
      selectedPieces.push(pieceId);
      this.shipmentService.generatePiecesBatchLabel(selectedPieces).subscribe({
        next: () => {
          this.viewIndividualPieceLabel(pieceId);
          this.behaviourService.sendEvent('labelGenerated');
          this.updatedForm.emit(this.shipmentData.shipmentID);
        },
        error: () => {
          this.snackBarService.dismissSnackbar();
        },
      });
    } else {
      this.manifestIndividualBabyshipment(
        this.shipmentData.shipmentID,
        this.shipmentData.productCode
      ).subscribe(res => this.handleManifestResponse(this.shipmentData.shipmentID, res));
    }
  }

  viewIndividualPieceLabel(pieceId) {
    const selectedPieces = [];
    selectedPieces.push(pieceId);
    this.shipmentService.fetchPiecesBatchLabel(selectedPieces).subscribe({
      next: () => {
        this.printLabel(pieceId);
      },
      error: () => {
        this.snackBarService.dismissSnackbar();
      },
    });
  }
  printLabel(pieceId) {
    this.shipmentService.getLabel('pieceID', pieceId).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }
  viewLabel(i) {
    if (this.shipmentData.productCode === 'A' || this.shipmentData.productCode === 'B') {
      const pieceId: any = this.shipmentForm.getRawValue().pieces[i].pieceID;
      if (pieceId !== '') {
        this.shipmentService.getLabel('pieceID', pieceId).subscribe({
          next: data => {
            this.openPrintView(data.label, pieceId);
          },
        });
      }
    } else {
      const shipmentID = this.shipmentForm.getRawValue().shipmentID;
      this.shipmentService.getIndividuaShiplabel('individualShipmentID', shipmentID).subscribe({
        next: data => {
          this.openPrintView(data.label, shipmentID);
        },
      });
    }
  }
  openPrintView(value, pieceId) {
    const dialogRef = this.dialog.open(LabelViewComponent, {
      data: {
        label: value,
        labelName: '',
        // labelName: `DHL_BBX_Label_${pieceId}`,
        format: 'pdf',
      },
      maxHeight: '90vh',
      maxWidth: '50vw',
    });

    dialogRef.afterClosed().subscribe(() => ``);
  }
  checkPieceLabelGenerated() {
    return this.shipmentForm
      .getRawValue()
      .pieces.some(item => item.status.toLowerCase() == 'Generated'.toLowerCase());
  }
  labelGenerateIcon(i) {
    return this.shipmentForm.getRawValue().pieces[i].status.toLowerCase() === 'not generated';
  }
  viewLabelIcon(i) {
    return this.shipmentForm.getRawValue().pieces[i].status.toLowerCase() === 'generated';
  }
  findDuplicate(i) {
    const pieceRef = this.shipmentForm.getRawValue().pieces[i].pieceReference;
    let test = 0;
    this.shipmentForm.getRawValue().pieces.filter(val => {
      if (val.pieceReference == pieceRef && pieceRef != null && pieceRef != '') test++;
    });
    this.findDuplicatePiecRef.emit(test > 1 ? true : false);
    return (this.isDuplicate = test > 1 && this.pieceLevelLabelPrint ? true : false);
  }

  calculateTotalWeight() {
    this.shipmentForm.controls?.['pieces'].valueChanges.subscribe(data => {
      this.totalWeight = 0;
      data?.forEach(piece => {
        this.totalWeight += Number(piece?.packageWeight);
      });
      this.totalWeight = Math.round(this.totalWeight * 10000) / 10000;
      return this.totalWeight;
    });
  }

    calculateTotalVolumeWeight() {
    this.shipmentForm.controls?.['pieces'].valueChanges.subscribe(data => {
      this.totalVolumeWeight = 0;
      let pieces=this.shipmentForm.getRawValue().pieces;
      pieces?.forEach(piece => {
        this.totalVolumeWeight += Number(piece?.volumetricWeight);
      });
      this.totalVolumeWeight = Math.round(this.totalVolumeWeight * 10000) / 10000;
      return this.totalVolumeWeight;
    });
  }



  openPieceDialog(i) {
    this.pieceIndex = i;
    this.pieceDialog = this.dialog.open(this.dialogPieceRef, {
      width: '35%',
    });
  }

  closPieceDialog() {
    this.pieceDialog.close();
    this.MultiPiecesGroup.reset();
  }

  isPieceGroupValid() {
    return this.MultiPiecesGroup.valid;
  }

  manifestIndividualBabyshipment(shipmentID, productCode) {
    const data = {
      shipmentID: shipmentID,
      productCode: productCode,
    };
    return this.shipmentService.individualBabyManifest(data);
  }

  handleManifestResponse(shipmentID, response: any) {
    const isSuccess = response?.error?.length == 0;
    if (isSuccess) {
      this.printLabelForIndShip(shipmentID);
      this.behaviourService.sendEvent('labelGenerated');
      this.updatedForm.emit(shipmentID);
    }
  }

  printLabelForIndShip(shipmentID) {
    this.shipmentService.getIndividuaShiplabel('individualShipmentID', shipmentID).subscribe({
      next: data => {
        this.shipmentService.labelWindowPrint(data.label);
      },
    });
  }
}
